const DAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

export const NOMBRES_DIA = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

export function parseHoraMinutos(str) {
  if (!str || typeof str !== 'string') return 0;
  const [h, m] = str.split(':').map((x) => parseInt(x, 10));
  return (Number.isFinite(h) ? h : 0) * 60 + (Number.isFinite(m) ? m : 0);
}

export function nowInTimezone(timeZone) {
  const tz = timeZone || 'America/Argentina/Buenos_Aires';
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const get = (type) => parts.find((p) => p.type === type)?.value;
    return {
      dia: DAY_MAP[get('weekday')] ?? 0,
      minutos: parseHoraMinutos(`${get('hour')}:${get('minute')}`),
    };
  } catch {
    const d = new Date();
    return { dia: d.getDay(), minutos: d.getHours() * 60 + d.getMinutes() };
  }
}

export function estaDentroHorarioUso(config) {
  if (!config || !config.usar_horarios) {
    return { permitido: true };
  }
  const { dia, minutos } = nowInTimezone(config.zona_horaria);
  const slot = (config.horarios || []).find((h) => h.dia === dia);
  if (!slot || !slot.activo) {
    return {
      permitido: false,
      motivo: 'Hoy no está dentro de los días hábiles configurados para el uso del sistema.',
    };
  }
  const desde = parseHoraMinutos(slot.desde);
  const hasta = parseHoraMinutos(slot.hasta);
  if (minutos >= desde && minutos < hasta) {
    return { permitido: true };
  }
  return {
    permitido: false,
    motivo: `Fuera del horario de uso (${slot.desde}–${slot.hasta}, ${config.zona_horaria}).`,
  };
}

export function formatearResumenHorarios(horarios) {
  if (!Array.isArray(horarios)) return '';
  return horarios
    .filter((h) => h.activo)
    .map((h) => `${NOMBRES_DIA[h.dia] || h.dia}: ${h.desde}–${h.hasta}`)
    .join(' · ');
}
